// Contas do card Precificação (Ficha Técnica). Markup simples, escolha do dono
// em 02/10/2026: markup = preço ÷ custo. Preço para um CMV = custo ÷ CMV.
// Centavos exatos (sem arredondar para ,90), também escolha do dono.

const EPS = 1e-6;

/** Preço que dá o CMV pedido (%), no centavo mais próximo — mesma conta do
 *  markup (CMV 25% = markup 4x dá o mesmo preço nos dois campos). */
export function precoParaCmv(custo, cmvPct) {
  const c = Number(custo) || 0;
  const m = Number(cmvPct) || 0;
  if (c <= 0 || m <= 0) return 0;
  return Math.round((c / (m / 100)) * 100 + EPS) / 100;
}

export function precoPorMarkup(custo, markup) {
  const c = Number(custo) || 0;
  const k = Number(markup) || 0;
  if (c <= 0 || k <= 0) return 0;
  return Math.round(c * k * 100 + EPS) / 100;
}

export function markupDe(preco, custo) {
  const p = Number(preco) || 0;
  const c = Number(custo) || 0;
  return p > 0 && c > 0 ? p / c : 0;
}

export function cmvDe(preco, custo) {
  const p = Number(preco) || 0;
  const c = Number(custo) || 0;
  return p > 0 ? (c / p) * 100 : 0;
}

export const brl = (n) => `R$ ${(Number(n) || 0).toFixed(2).replace(".", ",")}`;

/** "3,33x" — markup com 2 casas. */
export const textoMarkup = (k) => `${(Number(k) || 0).toFixed(2).replace(".", ",")}x`;

/** "30%" ou "27,5%". */
export const textoPct = (n) => {
  const v = Math.round((Number(n) || 0) * 10) / 10;
  return `${String(v).replace(".", ",")}%`;
};

/** Lê o que o lojista digitou ("3,5" ou "3.5") como número; NaN se vazio. */
export function lerNumero(txt) {
  const s = String(txt ?? "").trim().replace(",", ".");
  return s === "" ? NaN : Number(s);
}
